import { GridList } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrichmentAvailableListRow = ({
  children
}) => {
  return /*#__PURE__*/_jsx(GridList.Row, {
    children: children
  });
};